import * as React from 'react';

interface ArticleComponentCreditsProps {
  caption: string;
  credit: string;
  creditLink: string;
}
const ArticleComponentCredits: React.SFC<ArticleComponentCreditsProps> = props => {
  return (
    <div className="credits">
      <p className="caption">{props.caption}</p>
      <p className="credit">
        {props.credit} {props.creditLink && ' - '} {props.creditLink && <a href={props.creditLink}>link</a>}
      </p>
    </div>
  );
};

export default ArticleComponentCredits;
